module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="top-ad-banner"></div>\n<div class="page-header">\n	<div class="league-info">\n		<picture>\n			<source srcset="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'" type="image/png">\n			<img src="/assets/images/test-avatar.png?v=1" alt="">\n		</picture>\n		'+
((__t=( name ))==null?'':_.escape(__t))+
'\n	</div>\n\n	<select class="base-select js-change-round">\n		';
 _.each(rounds, function(round) { 
__p+='\n			';
 if(start_round <= round.id) { 
__p+='\n				<option value="'+
((__t=( round.id ))==null?'':_.escape(__t))+
'" '+
((__t=( (current_round == round.id) ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n					Round '+
((__t=( round.id ))==null?'':_.escape(__t))+
' '+
((__t=( round.final_prefix ))==null?'':_.escape(__t))+
'\n				</option>\n			';
 } 
__p+='\n		';
 }) 
__p+='\n	</select>\n\n</div>\n<div class="league-table shadow" >\n	<div class="table-body">\n		';
 if( current_fixture ) { 
__p+='\n			';
 _.each( current_fixture, function( fixture ) { 
__p+='\n				<div class="table-row-item">\n					<div class="opponent-block first">\n						<div class="opponent-avatar">\n							<picture>\n								<source srcset="'+
((__t=( process.env.AVATARS_PATH + fixture.first_opponent.user_id ))==null?'':_.escape(__t))+
'.png" type="image/png">\n								<img src="/assets/images/test-avatar.png?v=1" alt="">\n							</picture>\n						</div>\n						<div class="opponent-info">\n							<p class="opponent-team-name">\n								'+
((__t=( fixture.first_opponent.name ))==null?'':_.escape(__t))+
'\n							</p>\n							<p class="opponent-name">\n								'+
((__t=( fixture.first_opponent.firstname ))==null?'':_.escape(__t))+
'\n								'+
((__t=( fixture.first_opponent.lastname ))==null?'':_.escape(__t))+
'\n							</p>\n						</div>\n					</div>\n					<div class="fixture-info">\n						<div class="opponents-points">\n							';
 if(fixture.first_opponent.scoreflow && fixture.first_opponent.scoreflow[current_round]) { 
__p+='\n								<p class="'+
((__t=( fixture.first_opponent.is_playing_now ? 'playing-now' : '' ))==null?'':_.escape(__t))+
'">\n									'+
((__t=( fixture.first_opponent.scoreflow[current_round] ))==null?'':_.escape(__t))+
'\n								</p>\n							';
 }else if( fixture.first_opponent.proj_score ) { 
__p+='\n								<p class="proj-score">\n									'+
((__t=( fixture.first_opponent.proj_score ))==null?'':_.escape(__t))+
'\n								</p>\n							';
 } else { 
__p+='\n								-\n							';
 } 
__p+='\n\n							<span>Vs</span>\n\n							';
 if(fixture.second_opponent.scoreflow && fixture.second_opponent.scoreflow[current_round]) { 
__p+='\n								<p class="'+
((__t=( fixture.second_opponent.is_playing_now ? 'playing-now' : '' ))==null?'':_.escape(__t))+
'">\n									'+
((__t=( fixture.second_opponent.scoreflow[current_round] ))==null?'':_.escape(__t))+
'\n								</p>\n							';
 }else if( fixture.second_opponent.proj_score ) { 
__p+='\n								<p class="proj-score">\n									'+
((__t=( fixture.second_opponent.proj_score ))==null?'':_.escape(__t))+
'\n								</p>\n							';
 } else { 
__p+='\n								-\n							';
 } 
__p+='\n						</div>\n						<a href="'+
((__t=( matchup_url(fixture.first_opponent.id, fixture.second_opponent.id, current_round) ))==null?'':_.escape(__t))+
'"\n						   class="base-btn secondary-btn\n								js-matchup\n								'+
((__t=( (status == 'scheduled' ) ? 'disabled': '' ))==null?'':_.escape(__t))+
'"\n						>\n							Matchup\n						</a>\n					</div>\n					<div class="opponent-block second">\n						<div class="opponent-info">\n							<p class="opponent-team-name">\n								'+
((__t=( fixture.second_opponent.name ))==null?'':_.escape(__t))+
'\n							</p>\n							<p class="opponent-name">\n								'+
((__t=( fixture.second_opponent.firstname ))==null?'':_.escape(__t))+
'\n								'+
((__t=( fixture.second_opponent.lastname ))==null?'':_.escape(__t))+
'\n							</p>\n						</div>\n						<div class="opponent-avatar">\n							<picture>\n								<source srcset="'+
((__t=( process.env.AVATARS_PATH + fixture.second_opponent.user_id ))==null?'':_.escape(__t))+
'.png" type="image/png">\n								<img src="/assets/images/test-avatar.png?v=1" alt="">\n							</picture>\n						</div>\n					</div>\n				</div>\n			';
 } ) 
__p+='\n		';
 } else { 
__p+='\n            <div class="coming-soon">\n                <div class="text-block">\n                    <h5>LEAGUE FINALS FIXTURES WILL BE AVAILABLE AT THE CONCLUSION OF THE FANTASY HOME AND AWAY SEASON</h5>\n                </div>\n            </div>\n		';
 } 
__p+='\n	</div>\n</div>';
}
return __p;
};
